import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AvaliacaoRequisitoVagaDto, CreateAvaliacaoRequisitoVagaDto, CreateCandidatoVagaAvaliacaoRequisitoDto } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'modal-avaliacao.component',
  templateUrl: './modal-avaliacao.component.html',
  styleUrls: ['./modal-avaliacao.component.scss']
})
export class ModalAvaliacaoComponent {
  @Output() onSave = new EventEmitter<CreateCandidatoVagaAvaliacaoRequisitoDto[]>();

  perguntas: AvaliacaoRequisitoVagaDto[] = [];
  respostasSelecionadas: { avaliacaoRequisitoVagaId: string, respostaAvaliacaoRequisitoId: string }[] = [];
  saveLabel = "Avaliações";
  // paragrafoInicial = "Aqui você pode ver uma amostra do que o candidato verá quando clicar na avaliação de requisito. Essa é uma pré-visualização, ou seja, uma visualização antecipada do conteúdo.";
  paragrafoInicial = "Para que possamos avaliar seu perfil para a vaga, pedimos que responda às perguntas a seguir com atenção. Suas respostas nos ajudarão a entender melhor suas qualificações e experiência.";

  constructor(public activeModal: NgbActiveModal) { }

  fechar() {
    this.activeModal.dismiss();
  }

  selecionarResposta(perguntaId: string, respostaId: string) {
    const index = this.respostasSelecionadas.findIndex(r => r.avaliacaoRequisitoVagaId === perguntaId);

    if (index > -1) {
      this.respostasSelecionadas[index].respostaAvaliacaoRequisitoId = respostaId;
    } else {
      this.respostasSelecionadas.push({
        avaliacaoRequisitoVagaId: perguntaId,
        respostaAvaliacaoRequisitoId: respostaId
      });
    }
  }

  isRespostaSelecionada(perguntaId: string, respostaId: string): boolean {
    return this.respostasSelecionadas.some(
      r => r.avaliacaoRequisitoVagaId === perguntaId && r.respostaAvaliacaoRequisitoId === respostaId
    );
  }


  salvar() {
    const candidatoVagaAvaliacoes: CreateCandidatoVagaAvaliacaoRequisitoDto[] = this.respostasSelecionadas.map(resposta => {
      const dto = new CreateCandidatoVagaAvaliacaoRequisitoDto();
      dto.candidatoVagaId = "00000000-0000-0000-0000-000000000000";
      dto.avaliacaoRequisitoVagaId = resposta.avaliacaoRequisitoVagaId;
      dto.respostaAvaliacaoRequisitoId = resposta.respostaAvaliacaoRequisitoId;
      return dto;
    });

    this.onSave.emit(candidatoVagaAvaliacoes);
    this.fechar();
  }
}
